// Rich-text fields (bill descriptions, notes) are authored in the editor and stored as
// HTML. Detail views render that markup; compact list cells cannot — a <p> wrapper in a
// truncated one-liner just shows the tags. Strip to plain text for those.

const ENTITIES = [
    [/&nbsp;/gi, ' '],
    [/&lt;/gi, '<'],
    [/&gt;/gi, '>'],
    [/&quot;/gi, '"'],
    [/&#0?39;/gi, "'"],
    // &amp; last so "&amp;lt;" decodes to "&lt;" rather than "<".
    [/&amp;/gi, '&'],
];

export const stripHtml = (value) => {
    if (!value) return '';
    let text = String(value)
        // Block boundaries become spaces, otherwise "<p>a</p><p>b</p>" reads as "ab".
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<\/(p|div|li|tr|h[1-6]|blockquote)>/gi, ' ')
        .replace(/<[^>]*>/g, '');
    ENTITIES.forEach(([pattern, replacement]) => { text = text.replace(pattern, replacement); });
    return text.replace(/\s+/g, ' ').trim();
};

export default stripHtml;
